import { render, staticRenderFns } from "./setUnitCom.vue?vue&type=template&id=9508bd20&scoped=true"
import script from "./setUnitCom.vue?vue&type=script&lang=js"
export * from "./setUnitCom.vue?vue&type=script&lang=js"
import style0 from "./setUnitCom.vue?vue&type=style&index=0&id=9508bd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9508bd20",
  null
  
)

export default component.exports